import { Component, Input, OnInit } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { EnfafSelectOption } from '../enfaf-select/enfaf-select.component';

@Component({
  selector: 'enfaf-select-light',
  imports: [MatFormFieldModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatOptionModule],
  templateUrl: './enfaf-select-light.component.html',
  styleUrls: ['./enfaf-select-light.component.scss']
})
export class EnfafSelectLightComponent implements OnInit {
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() placeholder: string = 'Selecciona uno';
  @Input() errorLabel: string = '';
  @Input() control: any;
  @Input() options: EnfafSelectOption[] = [];
  @Input() hint?: string;
  @Input() subscriptSizing: 'fixed' | 'dynamic' = 'fixed';

  opened = false;

  get hasValue() {
    return this.control && this.control.value !== null && this.control.value !== '';
  }

  constructor() {}

  ngOnInit(): void {}

  onOpenedChange($event: boolean) {
    this.opened = $event;
  }
}
